export const getImagePath = (imageNameWithExtension: string): string => {
	return require(`./${imageNameWithExtension}`);
};
export const hamburgerDefaultIcon = getImagePath("hamburger-default-icon.svg");
export const searchDefaultIcon = getImagePath("search-default-icon.svg");
export const notificationDefaultIcon = getImagePath(
	"notification-default-icon.svg"
);
export const userDefaultIcon = getImagePath("user-default-icon.svg");
export const logoutDefaultIcon = getImagePath("logout-default-icon.svg");
export const userImg = getImagePath("user-img.png");
export const arrowDownDefaultIcon = getImagePath("arrow-down-default-icon.svg");
export const arrowLeftDefaultIcon = getImagePath("arrow-left-default-icon.svg");
export const arrowRightDefaultIcon = getImagePath(
	"arrow-right-default-icon.svg"
);

export const collapseUpDefaultIcon = getImagePath(
	"collapse-up-default-icon.svg"
);
export const collapseDownDefaultIcon = getImagePath(
	"collapse-down-default-icon.svg"
);
export const closeDefaultIcon = getImagePath("close-default-icon.svg");
export const logo = getImagePath("logo.png");
export const checkboxCheckedPrimaryIcon = getImagePath(
	"checkbox-checked-primary-icon.svg"
);
export const checkboxDefaultOutlineIcon = getImagePath(
	"checkbox-default-outline-icon.svg"
);
export const radioCheckedPrimaryIcon = getImagePath(
	"radio-checked-primary-icon.svg"
);
export const radioUncheckedDefaultIcon = getImagePath(
	"radio-unchecked-default-icon.svg"
);
export const uisGraphBarPrimaryIcon = getImagePath(
	"uis_graph-bar-primary-icon.svg"
);
export const dollarPrimaryIcon = getImagePath("dollar-primary-icon.svg");
export const userPrimaryIcon = getImagePath("user-primary-icon.svg");
export const basketPrimaryIcon = getImagePath("basket-primary-icon.svg");
export const revenueGraph = getImagePath("revenue-graph.png");
export const salesGraph = getImagePath("sales-graph.png");
export const ascendingArrowIcon = getImagePath("descending-arrow-icon.svg");
export const descendingArrowIcon = getImagePath("ascending-arrow-icon.svg");
export const defaultSortIcon = getImagePath("default-sort-icon.svg");
export const LoginLogo = getImagePath("login-logo.png");
export const closeWhiteIcon = getImagePath("close-white-icon.svg");
export const hidePasswordDefaultIcon = getImagePath(
	"hide-password-default-icon.svg"
);
export const showPasswordDefaultIcon = getImagePath(
	"show-password-default-icon.svg"
);
export const columnPrimaryIcon = getImagePath("column-primary-icon.svg");
export const addPrimaryIcon = getImagePath("add-primary-icon.svg");
export const filterPrimaryIcon = getImagePath("filter-primary-icon.svg");
export const exportPrimaryIcon = getImagePath("export-primary-icon.svg");
export const downloadPrimaryIcon = getImagePath("download-primary-icon.svg");
export const printerPrimaryIcon = getImagePath("printer-primary-icon.svg");
export const checkboxWhiteOutlineIcon = getImagePath(
	"checkbox-white-outline-icon.svg"
);
export const checkboxCheckedWhiteIcon = getImagePath(
	"checkbox-checked-white-icon.svg"
);
export const menuThreeDotsDefaultIcon = getImagePath(
	"menu-three-dots-default-icon.svg"
);
export const crossPrimaryIcon = getImagePath("cross-primary-icon.svg");
export const editSquarePrimaryIcon = getImagePath(
	"edi-square-primary-icon.svg"
);
export const notesPrimaryIcon = getImagePath("notes-primary-icon.svg");
export const refreshGreyIcon = getImagePath("refresh-grey-icon.svg");
export const refreshPrimaryIcon = getImagePath("refresh-primary-icon.svg");
export const reportSearchPrimaryIcon = getImagePath(
	"report-search-primary-icon.svg"
);
export const reportSearchDefaultIcon = getImagePath(
	"report-search-default-icon.svg"
);
export const documentCopyPrimaryIcon = getImagePath(
	"document-copy-primary-icon.svg"
);
export const circleTickPrimaryIcon = getImagePath(
	"circle-tick-primary-icon.svg"
);
export const circleTickGreenIcon = getImagePath("circle-tick-green-icon.svg");
export const circleOutlinePrimaryIcon = getImagePath(
	"circle-outline-primary-icon.svg"
);
export const circleOutlineDefaultIcon = getImagePath(
	"circle-outline-default-icon.svg"
);
export const saveMultiplePrimaryIcon = getImagePath(
	"save-multiple-primary-icon.svg"
);
export const notesTickPrimaryIcon = getImagePath("notes-tick-primary-icon.svg");
export const magnifyingGlassPrimaryIcon = getImagePath(
	"magnifying-glass-primary-icon.svg"
);
export const charmNotesTickPrimaryIcon = getImagePath(
	"charm-notes-tick-primary-icon.svg"
);
export const copyPrimaryIcon = getImagePath("copy-primary-icon.svg");
export const attachmentLinkPrimaryIcon = getImagePath(
	"attachment-link-primary-icon.svg"
);
export const editUnderlinePrimaryIcon = getImagePath(
	"edit-underline-primary-icon.svg"
);
export const plusDefaultIcon = getImagePath("plus-default-icon.svg");
export const plusPrimaryIcon = getImagePath("plus-primary-icon.svg");
export const uploadPrimaryIcon = getImagePath("upload-primary-icon.svg");
export const uploadIcon = getImagePath("upload-icon.svg");
export const chipCloseDefaultIcon = getImagePath("chip-close-default-icon.svg");
export const attachmentLinkGreenIcon = getImagePath(
	"attachment-link-green-icon.svg"
);
export const datePickerDefaultIcon = getImagePath(
	"date-picker-default-icon.svg"
);
export const buildingDefaultIcon = getImagePath("building-default-icon.svg");
export const airplaneDefaultIcon = getImagePath("airplane-default-icon.svg");
export const carDefaultIcon = getImagePath("car-default-icon.svg");
export const deleteIcon = getImagePath("delete-icon.svg");
export const disablePrimaryIcon = getImagePath("disable-primary-icon.svg");
export const pendingAccessPrimaryIcon = getImagePath(
	"pending-access-primary-icon.svg"
);
export const taskListSquareDefaultIcon = getImagePath(
	"task-list-square-default-icon.svg"
);
export const arrowUpDefaultIcon = getImagePath("arrow-up-default-icon.svg");
export const errorIcon = getImagePath("error.svg");
export const warningIcon = getImagePath("warning-icon.svg");
// export const brandingLogo = getImagePath("logo.png");
export const brandingLogo = getImagePath("white-logo.png"); //For ACSA branch only changed branding logo
export const eyeOutlinedDarkBlackIcon = getImagePath(
	"eye-outlined-dark-black-icon.svg"
);
export const failedRedIcon = getImagePath("failed-red-icon.svg");
export const successGreenIcon = getImagePath("success-green-icon.svg");
export const clarityGroupLinePrimaryIcon = getImagePath(
	"clarity-group-line-primary-icon.svg"
);
export const clarityEmployeeGroupLinePrimaryIcon = getImagePath(
	"clarity-employee-group-line-primary-icon.svg"
);
export const taskListSquareRtlPrimaryIcon = getImagePath(
	"task-list-square-rtl-primary-icon.svg"
);
export const biJournalArrowRightPrimaryIcon = getImagePath(
	"bi-journal-arrow-right-primary-icon.svg"
);
export const systemGraphIncreasePrimaryIcon = getImagePath(
	"system-graph-increase-primary-icon.svg"
);
export const trophySecondaryPrimaryIcon = getImagePath(
	"trophy-secondary-primary-icon.svg"
);
export const likePrimaryIcon = getImagePath("like-primary-icon.svg");
export const priceAdjustmentFormula = getImagePath(
	"price-adjustment-formula.jpg"
);
export const preferencePoint_80_20 = getImagePath("preference-point-80-20.jpg");
export const preferencePoint_90_10 = getImagePath("preference-point-90-10.jpg");
export const preferencePointMax_80_20 = getImagePath(
	"preference-point-max-80-20.jpg"
);
export const preferencePointMax_90_10 = getImagePath(
	"preference-point-max-90-10.jpg"
);
export const dragIcon = getImagePath("drag-icon.png");
export const bulletListSquarePrimaryIcon = getImagePath(
	"bullet-list-square-primary-icon.svg"
);
export const loadingCirclePrimaryIcon = getImagePath(
	"loading-circle-primary-icon.svg"
);
export const lockClosedPrimaryIcon = getImagePath(
	"lock-closed-primary-icon.svg"
);
export const progressCheckPrimaryIcon = getImagePath(
	"progress-check-primary-icon.svg"
);
export const progressPartialCheckPrimaryIcon = getImagePath(
	"progress-partial-check-primary-icon.svg"
);
export const invoiceImgIcon = getImagePath("invoice-img.png");
export const ordersPrimaryIcon = getImagePath("orders-primary-icon.svg");
export const expenditurePrimaryIcon = getImagePath(
	"expenditure-primary-icon.svg"
);
export const requisitionsPrimaryIcon = getImagePath(
	"requisitions-primary-icon.svg"
);
export const bidsPrimaryIcon = getImagePath("bids-primary-icon.svg");
export const totalBudgetPrimaryIcon = getImagePath(
	"total-budget-primary-icon.svg"
);
export const availableBudgetPrimaryIcon = getImagePath(
	"available-budget-primary-icon.svg"
);
export const contractPrimaryIcon = getImagePath("contract-primary-icon.svg");
export const dashboardAnalysisChartImage = getImagePath(
	"dashboard-analysis-chart.png"
);
export const dashboardBudgetChartImage = getImagePath(
	"dashboard-budget-chart.png"
);
export const plusWhiteIcon = getImagePath("plus-white-icon.svg");
export const plusDefaultBlueIcon = getImagePath("plus-default-blue-icon.svg");
export const clockDefaultIcon = getImagePath("clock-default-icon.svg");
export const progressClockPinkIcon = getImagePath(
	"progress-clock-pink-icon.svg"
);
export const notesTickBlueIcon = getImagePath("notes-tick-blue-icon.svg");
export const settingPrimaryIcon = getImagePath("setting-primary-icon.svg");
export const settingDefaultIcon = getImagePath("setting-default-icon.svg");
export const settingDarkGreyIcon = getImagePath("setting-dark-grey-icon.svg");
export const budgetManagementPrimaryIcon = getImagePath(
	"budget-management-primary-icon.svg"
);
export const budgetManagementDarkGreyIcon = getImagePath(
	"budget-management-dark-grey-icon.svg"
);
export const budgetManagementDefaultIcon = getImagePath(
	"budget-management-default-icon.svg"
);
export const chatPrimaryIcon = getImagePath("chat-primary-icon.svg");
export const letterPreviewIcon = getImagePath("letter-preview-icon.svg");
export const swapVerticalIcon = getImagePath("swap-vertical-icon.svg");
export const swapVerticalGreyIcon = getImagePath("swap-vertical-grey-icon.svg");
export const csdIntegrationDarkGreyIcon = getImagePath(
	"csd-integration-dark-grey-icon.svg"
);
export const csdIntegrationPrimaryIcon = getImagePath(
	"csd-integration-primary-icon.svg"
);
export const csdIntegrationDefaultIcon = getImagePath(
	"csd-integration-default-icon.svg"
);
export const gridViewOutline = getImagePath("grid-view-outline.svg");
export const consolidatedViewIcon = getImagePath("consolidated-view-icon.png");
export const detailedViewIcon = getImagePath("detailed-view-icon.png");
export const downRedArrowIcon = getImagePath("down-arrow.svg");
export const upGreenArrowIcon = getImagePath("up-arrow.svg");
export const forwardRedIcon = getImagePath("forward-red-icon.svg");
export const backwardGreenIcon = getImagePath("backward-green-icon.svg");
// New Dashboards Images
export const budgetAllocationPendingIcon = getImagePath(
	"budget-allocation-pending.png"
);
export const finAllocationCompletedIcon = getImagePath(
	"fin-allocation-completed.png"
);
export const opexCapexChartIcon = getImagePath("opex-capex-chart.png");
export const projectedIncomeChartIcon = getImagePath(
	"projected-income-chart.png"
);
export const deptAllocationInProgress = getImagePath(
	"dept-allocation-in-progress.png"
);
export const budgetExpenseOpexChart = getImagePath(
	"budget-expense-opex-chart.png"
);
export const budgetExpenseCapexChart = getImagePath(
	"budget-expense-capex-chart.png"
);
export const programmeBudgetChart = getImagePath("programme-budget-chart.png");
export const departmentalAllocationChart = getImagePath(
	"departmental-allocation-chart.png"
);
// New Dashboards Images - END
export const tickGreenIcon = getImagePath("tick-green-icon.svg");
export const cancelRedIcon = getImagePath("cancel-red-icon.svg");
export const changeRequestCompletedIcon = getImagePath(
	"change-request-completed-icon.svg"
);
export const circleTickGreenFilledIcon = getImagePath(
	"circle-tick-green-filled-icon.svg"
);
export const circleCancelRedFilledIcon = getImagePath(
	"circle-cancel-red-filled-icon.svg"
);
export const emailIcon = getImagePath("email-icon-blue.svg");
// Vendor Portal Icons - START
export const bookQuestionMarkPrimaryIcon = getImagePath(
	"book-question-mark-primary-icon.svg"
);
export const invoiceSubmissionPrimaryIcon = getImagePath(
	"invoice-submission-primary-icon.svg"
);
export const carbonBuildingPrimaryIcon = getImagePath(
	"carbon-building-primary-icon.svg"
);
export const hammerPrimaryIcon = getImagePath("hammer-primary-icon.svg");
export const journalArrowTruePrimaryIcon = getImagePath(
	"journal-arrow-true-primary-icon.svg"
);
// Vendor Portal Icons - END
export const requisitionOnHoldIcon = getImagePath(
	"requisition-on-hold-icon.svg"
);
// Contract Management Dashboard - START
export const editIcon = getImagePath("ic-edit.png");
export const refreshIcon = getImagePath("ic-refresh.png");
export const handShakeIcon = getImagePath("ic-hand-shake.png");
export const moneyIcon = getImagePath("ic-money.jpeg");
export const amountIcon = getImagePath("ic-amount.png");
export const upArrowIcon = getImagePath("up-arrow-green.svg");
export const dataChartIcon = getImagePath("ic-data-chart.png");
export const contractAmountChartIcon = getImagePath(
	"ic-contract-amount-chart.png"
);
export const contrDashboardSupplierIcon = getImagePath("ic-supplier.png");
export const pieChart = getImagePath("pie-chart.png");
export const pieChartWithLabel = getImagePath("pie-chart-with-label.png");
export const contractExpiredIn12Months = getImagePath("12-month-duration.svg");
export const contractExpiredIn8Months = getImagePath("8-month-duration.svg");
export const contractExpiredIn6Months = getImagePath("6-month-duration.svg");
export const contractExpiredIn3Months = getImagePath("3-month-duration.svg");
export const contractExpiredIn1Months = getImagePath("1-month-duration.svg");
// Contract Management Dashboard - END
// Performance Evaluation - Summary Grid - START
export const cancelledContractStatus = getImagePath(
	"cancelled-contract-status.png"
);
export const onHoldContractStatus = getImagePath("on-hold-contract-status.png");
// Performance Evaluation - Summary Grid - END
export const shuttleDefaultIcon = getImagePath("shuttle-default-icon.svg");
export const supplierInvoiceLogo = getImagePath("supplier-invoice-logo.jpg");
// Contract Summary Grid
export const infoIcon = getImagePath("info-icon.png");
export const dataImportIcon = getImagePath("data-import-icon.svg");
export const importActionIcon = getImagePath("import-action-icon.svg");
export const supplierIcon = getImagePath("supplier-icon.svg");
export const likeIcon = getImagePath("like-icon.svg");
export const orangeHoldRequestIcon = getImagePath(
	"orange-hold-request-icon.png"
);
export const greyHoldRequestIcon = getImagePath("grey-hold-request-icon.png");
export const orangeHoldRemoveIcon = getImagePath("orange-hold-remove-icon.png");
export const poIcon = getImagePath("po-icon.svg");
export const penaltyClauseIcon = getImagePath("penalty-clause-icon.svg");
export const redTerminationRequestIcon = getImagePath(
	"red-termination-requested-icon.png"
);
export const greyTerminationRequestIcon = getImagePath(
	"grey-termination-request-icon.png"
);
export const terminatedIcon = getImagePath("terminated-icon.png");
export const terminateIcon = getImagePath("terminate-icon.svg");
export const greenTerminateIcon = getImagePath("green-terminate-icon.svg");
export const penSignIcon = getImagePath("pen-sign-icon.png");
// Contract Summary Grid - END
export const pendingAttachment = getImagePath("pending-attachment.svg");
export const microsoftDynamicsCertificate = getImagePath(
	"microsoft-dynamics-certificate.png"
);
export const businessAgreementLetter = getImagePath(
	"business-agreement-letter.png"
);
export const cv = getImagePath("cv.png");
export const poTemplate = getImagePath("poTemplate.png");
// Finance Statement Dashboard
export const expenseIcon = getImagePath("expense-icon.svg");
export const assetsCurrentIcon = getImagePath("assets-current-icon.svg");
export const assetsNonCurrentIcon = getImagePath("assets-noncurrent-icon.svg");
export const revenueIcon = getImagePath("revenue-icon.svg");
export const bag = getImagePath("bag-image.png");
export const speedMeter = getImagePath("speed-meter.png");
export const barChart3d = getImagePath("3d-bar-chart.png");
export const solidWhite = getImagePath("solid_white.svg");
export const cartIcon = getImagePath("cart-icon.svg");
// CSD Integration
export const fullyIntegratedIcon = getImagePath("fully-integrated-icon.svg");
export const partiallyIntegratedIcon = getImagePath(
	"partially-integrated-icon.svg"
);
export const failedIntegrationIcon = getImagePath(
	"failed-integration-icon.svg"
);
export const externalUserIcon = getImagePath("external-user-icon.svg");
export const internalUserIcon = getImagePath("internal-user-icon.svg");
export const csdIntegrationUserIcon = getImagePath("csd-integration-icon.svg");
export const internalUserCsdDailyUpdateIcon = getImagePath(
	"internal-user-csd-daily-update-icon.svg"
);
export const detailIcon = getImagePath("detail-icon.svg");
export const erpDatabase = getImagePath("erp-database.svg");
export const companyAddress = getImagePath("erp-db-company.svg");
export const glAccount = getImagePath("gl-account.svg");
export const organizationLogo = getImagePath("organization-logo.svg");
export const systemModuleRegistration = getImagePath(
	"system-module-registration.svg"
);
export const bidCommitteeMeetingIcon = getImagePath(
	"meeting-bid-committee.svg"
);
export const activateBidCommitteeIcon = getImagePath(
	"activate-bid-committee.svg"
);
export const commentIcon = getImagePath("comment-icon.svg");
export const deleteBlackIcon = getImagePath("delete.svg");
export const deletePrimaryIcon = getImagePath("delete-primary-icon.svg");
export const termExpiredIcon = getImagePath("term-expired-icon.svg");
export const reportSearchGreenIcon = getImagePath(
	"report-search-green-icon.svg"
);
export const reportSearchOrangeIcon = getImagePath(
	"report-search-orange-icon.svg"
);
export const noOfDepartmentIcon = getImagePath("no-of-department-icon.svg");
export const totalBudgetIcon = getImagePath("tax-deduction.svg");
export const varianceIcon = getImagePath("variance.svg");
export const blackQueenIcon = getImagePath("black-chess-queen.svg");
export const extendTermIcon = getImagePath("extend-term-icon.svg");
export const batteryImage = getImagePath("battery-image.png");
export const calenderIcon = getImagePath("calender-icon.svg");
export const joinedAttendeesIcon = getImagePath("joined-attendees.svg");
export const notJoinedAttendeesIcon = getImagePath("not-joined-attendees.svg");
export const startMeetingIcon = getImagePath("start-meeting-icon.svg");
export const endMeetingIcon = getImagePath("meeting-end-icon.svg");
export const cancelMeetingRedIcon = getImagePath("cancel-meeting-red-icon.svg");
export const commentBlackIcon = getImagePath("comment-black-icon.svg");
export const csdIntegrationVendorPortal = getImagePath(
	"csd-integration-vendor-portal-icon.svg"
);
export const saveDefaultIcon = getImagePath("save-icon.svg");
export const lockedTabIcon = getImagePath("locked-tab-icon.svg");
export const openTabIcon = getImagePath("open-tab-icon.svg");
export const manualBidUpload = getImagePath("manual-bid-icon.svg");
export const handDeliveredDocumentIcon = getImagePath(
	"hand-delivered-document-icon.svg"
);
export const openIcon = getImagePath("open-icon.svg");
export const activateRedCommitteeIcon = getImagePath("activate-red-icon.svg");
export const bidEvaluationSummaryIcon = getImagePath(
	"bid-evaluation-summary-icon.svg"
);
export const questionMarkIcon = getImagePath("question-mark-icon.svg");
export const remainingBidIcon = getImagePath("remaining-bid-icon.svg");
export const acceptedBidIcon = getImagePath("accepted-bid-icon.svg");
export const adjudicationIcon = getImagePath("adjudication-icon.svg");
export const cancelDisableRedIcon = getImagePath("cancel-disable-icon.svg");
export const pageArrowIcon = getImagePath("page-arrow-icon.svg");
export const twoColumnsIcon = getImagePath("two-columns-icon.svg");
export const checkListIcon = getImagePath("checklist-icon.svg");
export const remittanceIcon = getImagePath("remittance-icon.svg");
export const invoiceReportIcon = getImagePath("invoice-report-icon.svg");
export const bidReportIcon = getImagePath("bid-summary-grid-report.svg");
export const submittedForReviewIcon = getImagePath(
	"submitted-for-review-icon.png"
);
export const programmePrimaryIcon = getImagePath("programmes-primary-icon.svg");
